module.exports = __webpack_public_path__ + "static/media/member_sample_basket_01.5aad4559.jpg";